import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import {
  Grid,
  Form,
  Button,
  Header,
  Icon,
  Modal,
  Popup,
} from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';

import { EDIT_SERVED_ITEM_FORM_NAME, InputMode } from 'Common/FormEnum';
import { EditServedItemFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import { SelectField, InputField, Checkbox } from 'Common/SemanticWrapper';

import MPWApi from 'API/MPWApi';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { NutritionCodeEnum } from 'Common/Constants/Enumeration/NutritionCodeEnum';
import { SemanticUiColorPickerWrapper } from 'Common/ReduxFormFields';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { formatToCashExtraPrecision } from 'Common/FormHelper';
import { CategoryEnum } from '../helpers/constants';
import {
  ItemIdLetterOptions,
  NutritionCodeOptions,
  ItemCategoryOptions,
  AlternateItemOptions,
  ConvertAmountColumns,
  ProhibitedFlagColumns,
  DefaultPrice,
  PriceFields,
  OverflowableTableProps,
  DefaultConvertAmount,
  ConvertAmountOptions,
  ConvertAmountFields,
  priceFormat,
} from '../helpers/EditItemHelpers';

class PricesGrid extends Component {
  state = {
    showConvertAmountModal: false,
    showProhibitedFlagModal: false,
    prohibitedFlagData: [],
    openedItemCategory: false,
  };

  PricesMenuOptions(row, disabled) {
    const { change, formValues } = this.props;

    return [
      {
        icon: 'flag',
        text: disabled ? 'View Prohibited Flags' : 'View/Edit Prohibited Flags',
        handler: () => {
          this.setState({
            showProhibitedFlagModal: true,
            prohibitedFlagData: Object.keys(row.original.ProhibitedFlag).map(
              key => ({
                status: key,
                value: row.original.ProhibitedFlag[key],
                index: row.index,
                disabled: disabled,
              })
            ),
          });
        },
      },
      {
        icon: 'cancel',
        text: 'Delete',
        handler: () => {
          const deletedPrices = _.cloneDeep(formValues[Fields.Prices]);
          deletedPrices.splice(row.index, 1);
          change(Fields.Prices, deletedPrices);
        },
        disabledWhen: () => row.original.GradeId === '00' || disabled,
      },
    ];
  }

  columns = [
    {
      Header: 'Grade',
      id: 'Grade',
      maxWidth: 80,
      Cell: row => {
        const gradeOptions = this.props.grades
          .map(grade => ({
            text: grade.Id,
            value: grade.Id,
          }))
          .filter(
            grade =>
              grade.value === row.original.GradeId || grade.value !== '00'
          );
        return (
          <Field
            component={SelectField}
            compact
            className={'shorter'}
            options={gradeOptions}
            name={`${Fields.Prices}[${row.index}].${PriceFields.GradeId}`}
            disabled={row.original.GradeId === '00' || this.props.disabled}
            style={{ marginTop: 17.5 }}
          />
        );
      },
    },
    {
      Header: 'Free',
      id: 'Free',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.FreePrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Reduced',
      id: 'Reduced',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.ReducedPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Paid',
      id: 'Student',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.StudentPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Teacher',
      id: 'Teacher',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.TeacherPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Adult',
      id: 'Adult',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.AdultPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Staff',
      id: 'Staff',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.StaffPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'Catered',
      id: 'Catered',
      width: 85,
      resizable: false,
      sortable: false,
      Cell: row => (
        <Field
          label={false}
          compact
          component={InputField}
          name={`${Fields.Prices}[${row.index}].${PriceFields.CateredPrice}`}
          maxLength={6}
          formatOnBlur={priceFormat}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: 'State Reimbursable',
      id: 'StateReimbursable',
      minWidth: 150,
      sortable: false,
      style: {
        textAlign: 'center',
      },
      Cell: row => (
        <Field
          label={false}
          component={Checkbox}
          name={`${Fields.Prices}[${row.index}].${PriceFields.StateReimbursable}`}
          disabled={this.props.disabled}
        />
      ),
    },
    {
      Header: '',
      resizable: false,
      width: 50,
      sortable: false,
      Cell: gridProps => {
        const disabled = this.props.disabled;
        return GridContextMenu({
          gridProps,
          options: this.PricesMenuOptions(gridProps, disabled),
        });
      },
    },
  ];

  render() {
    const { error, touched } = this.props;

    return (
      <Fragment>
        <Grid.Column>
          <Form.Field error={touched && error ? true : false}>
            {error && touched ? (
              <span className={'error input--message-error'}>{error}</span>
            ) : (
              undefined
            )}
            <ReactTable
              columns={this.columns}
              data={this.props.data ? this.props.data : []}
              resizable={false}
              defaultPageSize={10}
              {...OverflowableTableProps}
            />
          </Form.Field>
        </Grid.Column>
        <Modal size="small" open={this.state.showProhibitedFlagModal}>
          <Header icon="info circle" content={'Prohibited Flags'} />
          <Modal.Content>
            <ReactTable
              data={this.state.prohibitedFlagData}
              columns={ProhibitedFlagColumns}
              minRows={1}
              showPagination={false}
              showPageSizeOptions={false}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              primary
              onClick={() => {
                this.setState({
                  showProhibitedFlagModal: false,
                  prohibitedFlagData: [],
                });
              }}
            >
              <Icon className={'icon--white'} name="checkmark" />
              OK
            </Button>
          </Modal.Actions>
        </Modal>
      </Fragment>
    );
  }
}
class EditServedItemFormContainer extends Component {
  state = {
    showConvertAmountModal: false,
    showProhibitedFlagModal: false,
    prohibitedFlagData: [],
  };

  onTypeChange = () => {
    // Clear nutrition code when type is changed
    this.props.change(Fields.NutritionCode, null);
  };

  onNutritionCodeChange = (e, value) => {
    if (value !== '1') {
      this.props.change(Fields.Alternate, null);
    }
  };

  getConvertAmountDefaultGradeId(grades, selectedGrades) {
    const foundGrade = grades.find(
      grade =>
        grade.Id !== '00' &&
        selectedGrades.findIndex(
          g => g[ConvertAmountFields.GradeId] === grade.Id
        ) === -1
    );
    return foundGrade ? foundGrade.Id : null;
  }

  getConvertAmountModal = () => {
    const { change, formValues, loading, grades, isReadOnly } = this.props;
    return (
      <Modal size="small" open={this.state.showConvertAmountModal}>
        <Header icon="info circle" content={'Convert Amount'} />
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Button
                  content={'Add Grade'}
                  onClick={() => {
                    change(
                      Fields.ConvertAmounts,
                      (formValues && formValues[Fields.ConvertAmounts]
                        ? formValues[Fields.ConvertAmounts]
                        : []
                      ).concat([
                        {
                          ...DefaultConvertAmount,
                          [ConvertAmountFields.GradeId]: this.getConvertAmountDefaultGradeId(
                            grades,
                            formValues && formValues[Fields.ConvertAmounts]
                              ? formValues[Fields.ConvertAmounts]
                              : []
                          ),
                        },
                      ])
                    );
                  }}
                  disabled={
                    loading ||
                    isReadOnly ||
                    !formValues ||
                    (formValues[Fields.ConvertAmounts] &&
                      formValues[Fields.ConvertAmounts].length ===
                        grades.length - 1)
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReactTable
                  data={formValues ? formValues[Fields.ConvertAmounts] : []}
                  columns={ConvertAmountColumns(
                    grades,
                    ConvertAmountOptions.bind(this),
                    formValues ? formValues[Fields.ConvertAmounts] : [],
                    isReadOnly
                  )}
                  minRows={5}
                  pageSize={10}
                  {...OverflowableTableProps}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={() => {
              this.setState({ showConvertAmountModal: false });
            }}
          >
            <Icon className={'icon--white'} name="checkmark" />
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  getProhibitedFlagModal = () => {
    return (
      <Modal size="small" open={this.state.showProhibitedFlagModal}>
        <Header icon="info circle" content={'Prohibited Flags'} />
        <Modal.Content>
          <ReactTable
            data={this.state.prohibitedFlagData}
            columns={ProhibitedFlagColumns}
            minRows={1}
            showPagination={false}
            showPageSizeOptions={false}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            primary
            onClick={() => {
              this.setState({
                showProhibitedFlagModal: false,
                prohibitedFlagData: [],
              });
            }}
          >
            <Icon className={'icon--white'} name="checkmark" />
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  getAlternateTooltip = () => {
    return (
      <Popup
        basic
        trigger={<Icon size="large" name="question circle outline" />}
        content={
          <div>
            This is an Offline Mode setting. The setting only applies to
            reimbursable meals (Nutrition Code 1).
            <br />
            <br />
            In the unlikely event a student is served multiple reimbursable
            meals in the same serving day, the alternate item will be
            substituted.
            <br />
            <br />
            The alternate item must be a Nutrition Code 2 item.
          </div>
        }
      />
    );
  };

  getNutritionCodeTooltip = (isAlternate, isOVS) => {
    return isAlternate || isOVS ? (
      <Popup
        basic
        trigger={<Icon size="large" name="question circle outline" />}
        content={
          <div>
            {isAlternate
              ? 'This is configured as an alternate item of one or more reimbursable meals. '
              : ''}
            {isOVS
              ? 'This is used as the Offer vs. Serve meal for one or more sites. '
              : ''}
            These relationships must be removed before nutrition code can be
            changed.
          </div>
        }
      />
    ) : (
      undefined
    );
  };

  render() {
    const {
      formValues,
      loading,
      nutritionCodes,
      itemCategories,
      alternateItems,
      change,
      Id,
      isReadOnly,
    } = this.props;

    return (
      <Fragment>
        <Form name={EDIT_SERVED_ITEM_FORM_NAME}>
          <TitledCard title={'Item Information'}>
            <Grid>
              <Grid.Row columns={4}>
                <Grid.Column width={2}>
                  <Field
                    label="Item Type"
                    component={SelectField}
                    name={Fields.ItemIdLetter}
                    options={ItemIdLetterOptions}
                    compact
                    onChange={this.onTypeChange}
                    disabled={loading || isReadOnly || Id !== '0'}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Field
                    label={'Item Id'}
                    component={InputField}
                    name={Fields.ItemId}
                    maxLength={3}
                    mode={InputMode.Integer}
                    fluid
                    disabled={loading || isReadOnly || Id !== '0'}
                  />
                </Grid.Column>
                <Grid.Column width={3} />
                <Grid.Column width={8}>
                  <Field
                    label={
                      <Fragment>
                        Alternate Item {this.getAlternateTooltip()}
                      </Fragment>
                    }
                    component={SelectField}
                    name={Fields.Alternate}
                    options={AlternateItemOptions(alternateItems)}
                    disabled={
                      loading ||
                      isReadOnly ||
                      (formValues &&
                        formValues[Fields.NutritionCode] !==
                          NutritionCodeEnum.FederalType1Meal)
                    }
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    label="Description"
                    component={InputField}
                    name={Fields.Description}
                    maxLength={30}
                    disabled={loading || isReadOnly}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    label={
                      <React.Fragment>
                        Color
                        <Popup
                          basic
                          trigger={
                            <Icon size="large" name="question circle outline" />
                          }
                          content={
                            <div>
                              If selected, this color will be used instead of
                              the Item Category or Nutrition Code colors.
                            </div>
                          }
                        />
                      </React.Fragment>
                    }
                    reset
                    component={SemanticUiColorPickerWrapper}
                    name={Fields.Color}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    label="Short Description"
                    component={InputField}
                    name={Fields.ShortDescription}
                    maxLength={15}
                    disabled={loading || isReadOnly}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    label={'Item Category'}
                    component={SelectField}
                    name={Fields.ItemCategory}
                    options={
                      this.state.openedItemCategory
                        ? ItemCategoryOptions(
                            itemCategories.filter(
                              ic => ic.Id !== CategoryEnum.Planned
                            )
                          )
                        : ItemCategoryOptions(itemCategories)
                    }
                    onOpen={() => {
                      this.setState({ openedItemCategory: true });
                    }}
                    onClose={() => {
                      this.setState({ openedItemCategory: false });
                    }}
                    disabled={
                      loading ||
                      isReadOnly ||
                      (formValues &&
                        formValues[Fields.ItemCategory] ===
                          CategoryEnum.Planned)
                    }
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Field
                    label={
                      <Fragment>
                        Nutrition Code{' '}
                        {this.getNutritionCodeTooltip(
                          formValues && formValues[Fields.IsAlternateItem],
                          formValues && formValues[Fields.IsOVSMeal]
                        )}
                      </Fragment>
                    }
                    options={NutritionCodeOptions(
                      nutritionCodes,
                      formValues ? formValues[Fields.ItemIdLetter] : ''
                    )}
                    className={'hideDisabled'}
                    component={SelectField}
                    name={Fields.NutritionCode}
                    onChange={this.onNutritionCodeChange}
                    disabled={
                      loading ||
                      isReadOnly ||
                      !formValues ||
                      !formValues[Fields.ItemIdLetter] ||
                      formValues[Fields.IsAlternateItem] ||
                      formValues[Fields.IsOVSMeal]
                    }
                  />
                </Grid.Column>
                <Grid.Column verticalAlign={'bottom'}>
                  <Button
                    content={'Convert Amount'}
                    onClick={() => {
                      this.setState({ showConvertAmountModal: true });
                    }}
                    disabled={
                      loading ||
                      !(
                        formValues &&
                        formValues[Fields.ItemIdLetter] === MealTypesEnum.Lunch
                      ) ||
                      !(
                        formValues &&
                        (formValues[Fields.NutritionCode] ===
                          NutritionCodeEnum.Fruit ||
                          formValues[Fields.NutritionCode] ===
                            NutritionCodeEnum.Vegetable)
                      )
                    }
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3} style={{ paddingTop: 14 }}>
                  <Field
                    label={
                      <Fragment>
                        SERVING COST <Icon name={'dollar'} />
                      </Fragment>
                    }
                    name={Fields.ServingCost}
                    component={InputField}
                    formatOnBlur={formatToCashExtraPrecision(4)}
                    mode={InputMode.Decimal}
                    numericSize={[7, 4]}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title={'Prices'}>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    content={'Add Grade'}
                    onClick={() => {
                      change(
                        Fields.Prices,
                        (formValues && formValues[Fields.Prices]
                          ? formValues[Fields.Prices]
                          : []
                        ).concat([
                          { ...DefaultPrice, [PriceFields.GradeId]: null },
                        ])
                      );
                    }}
                    disabled={loading || isReadOnly}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Field
                  name={Fields.Prices}
                  component={PricesGrid}
                  data={
                    formValues && formValues[Fields.Prices]
                      ? formValues[Fields.Prices]
                      : []
                  }
                  grades={this.props.grades || []}
                  disabled={loading || isReadOnly}
                  change={this.props.change}
                  formValues={this.props.formValues}
                />
              </Grid.Row>
            </Grid>
          </TitledCard>
          {this.getConvertAmountModal()}
        </Form>
      </Fragment>
    );
  }
}

const asyncValidate = (values, dispatch, props) => {
  if (props.Id !== '0') {
    return Promise.resolve();
  }

  const itemId = `${values[Fields.ItemIdLetter]}${values[Fields.ItemId]}`;

  return new Promise((resolve, reject) => {
    MPWApi.getGeneric(`/ServedItem/${itemId}`).then(values => {
      const errors = {};

      if (values.data.Data !== null) {
        errors[Fields.ItemId] = 'Id already in use.';
      }

      if (Object.keys(errors).length > 0) {
        reject(errors);
      } else {
        resolve();
      }
    });
  });
};

const validate = values => {
  var errors = {};

  if (_.isNil(values[Fields.ItemIdLetter])) {
    errors[Fields.ItemIdLetter] = 'Select an item type.';
  }
  if (!values[Fields.ItemId] || values[Fields.ItemId].length < 3) {
    errors[Fields.ItemId] = 'Enter a valid Item Id (3 digits).';
  }
  if (!values[Fields.Description]) {
    errors[Fields.Description] = 'Please enter a description.';
  }
  if (!values[Fields.ShortDescription]) {
    errors[Fields.ShortDescription] = 'Please enter a short description.';
  }
  if (_.isNil(values[Fields.NutritionCode])) {
    errors[Fields.NutritionCode] = 'Nutrition code must be selected.';
  }

  if (values[Fields.Prices]) {
    values[Fields.Prices].forEach((price, index) => {
      if (
        values[Fields.Prices].findIndex(p => p.GradeId === price.GradeId) !==
        index
      ) {
        errors[Fields.Prices] = 'Grades must be unique.';
      }
      if (!price.GradeId) {
        errors[Fields.Prices] = 'Grade must be set.';
      }
    });
  }

  return errors;
};

const EditServedItemForm = reduxForm({
  form: EDIT_SERVED_ITEM_FORM_NAME,
  asyncValidate,
  validate,
  enableReinitialize: true,
})(withRouter(EditServedItemFormContainer));

export { EditServedItemForm };



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/components/EditServedItemForm.js